import type { NamespaceCatalog } from '@/i18n/ns';
const copy: NamespaceCatalog<'interrupted'> = {
  bg: { interrupted: 'Гласовият отговор е прекъснат' },
  hr: { interrupted: 'Glasovni odgovor prekinut' },
  cs: { interrupted: 'Hlasová odpověď přerušena' },
  da: { interrupted: 'Talt svar afbrudt' },
  nl: { interrupted: 'Gesproken antwoord onderbroken' },
  en: { interrupted: 'Spoken reply interrupted' },
  et: { interrupted: 'Häälvastus katkestatud' },
  fi: { interrupted: 'Puhuttu vastaus keskeytetty' },
  fr: { interrupted: 'Réponse vocale interrompue' },
  de: { interrupted: 'Sprachantwort unterbrochen' },
  el: { interrupted: 'Η φωνητική απάντηση διακόπηκε' },
  hu: { interrupted: 'A hangos válasz megszakítva' },
  ga: { interrupted: 'Cuireadh isteach ar an bhfreagra labhartha' },
  it: { interrupted: 'Risposta vocale interrotta' },
  lv: { interrupted: 'Balss atbilde pārtraukta' },
  lt: { interrupted: 'Balso atsakymas nutrauktas' },
  mt: { interrupted: 'It-tweġiba bil-vuċi ġiet interrotta' },
  pl: { interrupted: 'Odpowiedź głosowa przerwana' },
  pt: { interrupted: 'Resposta falada interrompida' },
  ro: { interrupted: 'Răspuns vocal întrerupt' },
  sk: { interrupted: 'Hlasová odpoveď prerušená' },
  sl: { interrupted: 'Glasovni odgovor prekinjen' },
  es: { interrupted: 'Respuesta hablada interrumpida' },
  sv: { interrupted: 'Uppläsningen avbröts' },
};
export default copy;
